import {
  LEGACY_OPERATOR_ROLE_TYPE,
  isProductionManagerRole,
  isSinglePhaseWorkshopStation,
} from './operatorRoles';

/**
 * Vue « bureau » : UI manager (admin, pilotes production, legacy operators).
 * Note : les opérateurs de poste voient aussi toutes les commandes, via
 * filterBatchesForTrackingDashboard — cette fonction ne pilote plus que le layout.
 */
export function userSeesAllProductionLots(primaryRole, roleTypes = []) {
  const roles = Array.isArray(roleTypes) ? roleTypes.filter(Boolean) : [];
  if (roles.includes('administrator') || primaryRole === 'administrator') return true;
  if (roles.some((r) => isProductionManagerRole(r))) return true;
  if (primaryRole === LEGACY_OPERATOR_ROLE_TYPE || roles.includes(LEGACY_OPERATOR_ROLE_TYPE)) {
    return true;
  }
  if (!primaryRole) return roles.some((r) => !isSinglePhaseWorkshopStation(r));
  return !isSinglePhaseWorkshopStation(primaryRole);
}

/**
 * Lot visible pour un poste atelier (toutes commandes hors brouillon).
 */
export function batchVisibleToWorkshopUser(batch) {
  if (!batch) return false;
  return batch.status !== 'draft';
}

export function filterBatchesForProductionUser(batches) {
  const list = Array.isArray(batches) ? batches : [];
  return list.filter((b) => batchVisibleToWorkshopUser(b));
}
